import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import useStore from "../../_global/jsx/store.js";
import shallow from "zustand/shallow";
import axios from "axios";
import DOMPurify from "dompurify";
import {
    getHtmlForPDF,
    getPdfUrl,
    readyAccordions,
} from "../../_global/js/Utils.js";

const PageContent = (props) => {
    const [pageHtml, setPageHtml] = useState(
        "<h4>Loading information ...</h4>"
    );

    const [accordionReady, setaccordionReady] = useState(false);

    const {
        matrixData,
        setSummarySaveFunctionsReady,
        setPdfLink,
        setPageContentsLoaded,
    } = useStore(
        (state) => ({
            matrixData: state.matrixData,
            setSummarySaveFunctionsReady: state.setSummarySaveFunctionsReady,
            setPdfLink: state.setPdfLink,
            setPageContentsLoaded: state.setPageContentsLoaded,
        }),
        shallow
    );

    const pageData = matrixData["pages"][props.pageId];
    const { url, page_type } = pageData;
    const getPageContents = useCallback(async () => {
        let content = await axios.get(url);
        // let content = await axios.get(`https://mycorsnewcasio.herokuapp.com/${url}`);

        setPageHtml(content.data);
        setaccordionReady(true);
        setPageContentsLoaded(true);

        if (page_type === "Summary") {
            setTimeout(() => {
                const html = getHtmlForPDF();
                getPdfUrl(html)
                    .then((res) => {
                        setPdfLink(res.data["file_url"]);
                    })
                    .then(() => {
                        setSummarySaveFunctionsReady(true);
                    });
            }, 4000);
        }

        /* Watch the div that will contain page content. */
        /* Only AFTER innerHTML is dangerously set, run the accordion prep */
        const mutationObserver = new MutationObserver((entries) => {
            readyAccordions();
            mutationObserver.disconnect();
        });
        const parent = document.getElementById("swt-pageHTML");
        mutationObserver.observe(parent, { childList: true });
    }, [
        url,
        page_type,
        setPdfLink,
        setSummarySaveFunctionsReady,
        setPageContentsLoaded,
    ]);

    const retryContents = () => {
        getPageContents();
    };

    useEffect(() => {
        setPageContentsLoaded(false);
        getPageContents();
    }, [url, getPageContents, setPageContentsLoaded]);

    return (
        <div className="page-content">
            <div className={pageHtml ? "hide" : ""}>
                <p>We have encountered a problem retrieving information.</p>
                <button onClick={retryContents}>Retry</button>
            </div>
            <div
                id="swt-pageHTML"
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(pageHtml, {
                        ADD_ATTR: ["target"],
                    }),
                }}
            />
        </div>
    );
};

PageContent.propTypes = {
    pageId: PropTypes.string,
};

export default PageContent;
